'use client';

import { memo } from 'react';
import dynamic from 'next/dynamic';
import { AddToGoogleWalletProps } from './AddToGoogleWallet.types';

// Sized to the rendered "standard" Save-to-Google-Wallet button so the button
// swaps in without layout shift, and the area reads as a button (not broken)
// while the Google SDK script loads on first mount.
const WALLET_BUTTON_SIZE = 'tw:h-[2.875rem] tw:w-[10.5rem]';

const SaveToGooglePay = dynamic(() => import('@google-pay/save-button-react'), {
  ssr: false,
  loading: () => (
    <div
      data-cy="add-to-google-wallet-loading"
      aria-hidden="true"
      className={`${WALLET_BUTTON_SIZE} tw:rounded-full tw:bg-gray-light tw:animate-pulse`}
    />
  ),
});

/**
 * ## Invariants:
 * - Memoized so a parent re-render never rebuilds the element. Why:
 *   `@google-pay/save-button-react` re-runs `gapi.savetoandroidpay.render` on every
 *   update, repainting the button (flicker) and killing an in-flight click (PB-3350).
 */
export const AddToGoogleWallet = memo(function AddToGoogleWallet({
  jwt,
}: AddToGoogleWalletProps) {
  if (!jwt) return null;

  return <SaveToGooglePay height="standard" jwt={jwt} theme="dark" />;
});
